import { render, staticRenderFns } from "./ChatQueuesMultiselect.vue?vue&type=template&id=a9e3e8c4&scoped=true"
import script from "./ChatQueuesMultiselect.vue?vue&type=script&lang=js"
export * from "./ChatQueuesMultiselect.vue?vue&type=script&lang=js"
import style0 from "./ChatQueuesMultiselect.vue?vue&type=style&index=0&id=a9e3e8c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e3e8c4",
  null
  
)

export default component.exports